import en from "rsuite/esm/locales/en_US";
import ar from "rsuite/esm/locales/ar_EG";

export default { en, ar };
